module.exports = __webpack_public_path__ + "static/gavilanwork8-f616d8ea2b71492be7f677b6ac7df38b.png";